module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/caret-right-e61f58d58fbfbbe23a61d45f419e5ac1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/caret-right.svg
// module id = GiJn
// module chunks = 24